"use client";

import { FC, PropsWithChildren } from "react";
import { Flex, Heading } from "@chakra-ui/react";
import NextLink from "next/link";
import { ChevronLeftIcon } from "lucide-react";

type Props = {
  title: string;
  showBackLink?: boolean;
};

const Layout: FC<PropsWithChildren<Props>> = ({
  title,
  showBackLink = true,
  children,
}) => (
  <>
    <Flex p={5} mb={5} gap={3} alignItems="center">
      {showBackLink && (
        <NextLink href="/" aria-label="Back to welcome page">
          <ChevronLeftIcon size={32} />
        </NextLink>
      )}

      <Heading as="h1" size="3xl">
        {title}
      </Heading>
    </Flex>

    {children}
  </>
);

export default Layout;
